import React from "react";
import { Text, TouchableOpacity, StyleSheet } from "react-native";
import { useNavigate } from "react-router-dom";
import { colors, elevation } from "../theme";

/**
 * Round floating back button pinned to the bottom-left of the viewport.
 * Translucent on purpose so the content underneath stays partly visible.
 *
 * Uses position:fixed, so mount it outside any transformed ancestor (e.g. a
 * scroll container that carries a transform), or "fixed" becomes "fixed to
 * that box".
 *
 * Props:
 *  - onPress: overrides the default history-back navigation
 *  - style:   position/appearance overrides (e.g. aligning to a centered
 *             desktop column)
 */
const FloatingBackButton = ({ onPress, style }) => {
  const navigate = useNavigate();

  return (
    <TouchableOpacity
      dataSet={{ hover: "lift" }}
      style={[styles.button, style]}
      onPress={onPress || (() => navigate(-1))}
    >
      <Text style={styles.arrow}>←</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    position: "fixed",
    bottom: 20,
    left: 20,
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: colors.overlay,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10000,
    boxShadow: elevation.lg,
    elevation: 10,
  },
  arrow: {
    color: "#FFFFFF",
    fontSize: 28,
    fontWeight: "bold",
    lineHeight: 28,
  },
});

export default FloatingBackButton;
